import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Reports/OutstandingPaymentTable";
import Navbar from "../../Components/Navbar";
import ChangePasswordModal from "../../Components/Admin/ChangePasswordModal";
import { ToastContainer, toast } from "react-toastify";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../../Components/Styles/InputStyles";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import NotFoundModel from "../../Components/NotFoundModel";
import DeleteModel from "../../Components/Customers/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../../Config";
import EditUserModel from "../../Components/Customers/EditUserModel";
import SingleEntry from "../../Components/Customers/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import ViewModel from "../../Components/Payments/ViewModel";

const Payments = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);

  const [changePasswordModel, setChangePasswordModel] = useState(false);
  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("billId");
  const [openViewModel, setOpenViewModel] = useState(false);

  const [editUser, setEditUser] = useState(false);

  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const initialValues = {
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  //const isLoadingFetch = "";
  //const error = "";
  //const refetch = "";
  //const isRefetching = "";

  // ----- Getting Initial Data ------
  const fetchFunction = async () => {
    const body = new FormData();
    // body.append("filter", filter);
    // body.append("filterValue", filterValue);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("paymentStatus", 0);
    body.append("status", 0);
    return await axios.post(
      `${Config.apiUrl}/getoutstandingpaymentlist`,
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
  };

  const getAppReSuccess = (res) => {
    if (res.data.status == "NOK") error = true;
  };

  const getAppReError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getAppRegMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getAppReSuccess,
    onError: getAppReError,
  });

  useEffect(() => {
    getAppRegMutate();
  }, []);

  /*********** Export Function *********** */

  const getPaymentsExportApi = async () => {
    const body = new FormData();
    // body.append("filter", filter);
    // body.append("filterValue", filterValue);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("paymentStatus", 0);
    body.append("status", 0);
    return await axios.post(`${Config.apiUrl}/exportoutstandingpayment`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const submitHandlerForExport = (values) => {
    getPaymentsExport();
  };

  const GetExportDataSuccess = (data) => {
    // console.log(data);
    window.open(data.data.path, "_blank");
  };

  const GetExportDataError = (data) => console.log("error", data);

  const { isLoading: InitialLoadingForExport, mutate: getPaymentsExport } =
    useMutation(getPaymentsExportApi, {
      onSuccess: GetExportDataSuccess,
      onError: GetExportDataError,
    });

  /*********** End Export Function *********** */

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);

    getAppRegMutate();
  };

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>Outstading Payments Report</Title>
              <Underline />
            </div>
          </div>
          {/* <BoxTitle onClick={() => navigate(-1)}>
            <img src={Images.Arrow} alt="arrow" className="w-2" />
            <p>Admin</p>
          </BoxTitle> */}
          <div className="flex items-end justify-between">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              user={user}
              submitHandlerForExport={submitHandlerForExport}
            />

            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          {openViewModel && (
            <ViewModel
              setOpenViewModel={setOpenViewModel}
              selectedItem={selectedData}
              gTypeOfGame={gTypeOfGame}
            />
          )}

          <TableWrapper>
            <Table
              ApiData={error ? [] : data?.data?.list}
              setOpenDeleteModel={setOpenDeleteModel}
              setSelectedData={setSelectedData}
              setEditUser={setEditUser}
              setOpenViewModel={setOpenViewModel}
              setChangePasswordModel={setChangePasswordModel}
            />
          </TableWrapper>

          {/* {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />} */}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  submitHandlerForExport,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          {/* <p
              className="p-3 border-b border-gray-100 text-sm text-white px-5 bg-cyan-600 hover:bg-cyan-700 rounded-md py-2.5 text-sm"
              type="submit"
              onClick={submitHandlerForImport}
            >
              Import
            </p> */}
          <p
            className="p-3 border-b border-gray-100 text-sm text-white px-5 bg-cyan-600 hover:bg-cyan-700 rounded-md py-2.5 text-sm cursor-pointer right-0"
            disabled={InitialLoading}
            type="button"
            onClick={submitHandlerForExport}
          >
            Export
          </p>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const Uploader = ({ setOpenUploadModel }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <MdAdd className="text-white w-5 h-5" /> <p>Add User</p>
      </Button>
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full max-w-xl gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;
const ExportWrapper = tw.div` w-full cursor-pointer absolute top-10 right-0 bg-white shadow-md  rounded-md z-50`;

export default Payments;
